var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 797,
    viewBox: "0 0 557 797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.295 674.603L125.173 578.482C122.263 575.572 122.263 570.857 125.173 567.947L221.295 471.825C224.205 468.916 228.92 468.916 231.83 471.825L327.952 567.947C330.861 570.857 330.861 575.572 327.952 578.482L231.83 674.603C228.92 677.513 224.205 677.513 221.295 674.603Z",
    fill: "#B3DCF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M449.017 689.008L342.358 582.349L235.698 689.008L342.358 795.666L449.017 689.008Z",
    stroke: "#B3DCF0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.368 204.967L125.245 108.845C122.336 105.935 122.336 101.22 125.245 98.3105L221.368 2.18233C224.277 -0.727442 228.993 -0.727442 231.902 2.18233L328.024 98.3038C330.934 101.214 330.934 105.929 328.024 108.839L231.902 204.96C228.993 207.87 224.277 207.87 221.368 204.96V204.967Z",
    fill: "#F2F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.966 217.363L112.847 121.245C109.936 118.334 105.217 118.334 102.307 121.245L6.1874 217.363C3.27683 220.274 3.27681 224.993 6.1874 227.903L102.307 324.022C105.217 326.933 109.936 326.933 112.847 324.022L208.966 227.903C211.877 224.993 211.877 220.274 208.966 217.363Z",
    fill: "#B3DCF0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M450.688 220.963L344.029 114.304L237.369 220.963L344.029 327.622L450.688 220.963Z",
    stroke: "#62ACD9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M562.813 333.085L466.693 236.966C463.783 234.056 459.064 234.056 456.153 236.966L360.034 333.085C357.123 335.995 357.123 340.714 360.034 343.625L456.153 439.744C459.064 442.654 463.783 442.654 466.693 439.744L562.813 343.625C565.723 340.714 565.723 335.995 562.813 333.085Z",
    fill: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.905 557.214L7.78273 461.092C4.87294 458.183 4.87294 453.467 7.78273 450.558L219.701 238.641C222.611 235.731 227.326 235.731 230.236 238.641L326.358 334.762C329.268 337.672 329.268 342.387 326.358 345.297L114.44 557.214C111.53 560.124 106.815 560.124 103.905 557.214Z",
    fill: "#B7DCF2"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337.091 558.814L240.969 462.693C238.059 459.783 238.059 455.068 240.969 452.158L337.091 356.037C340.001 353.127 344.716 353.127 347.626 356.037L443.748 452.158C446.658 455.068 446.658 459.783 443.748 462.693L347.626 558.814C344.716 561.724 340.001 561.724 337.091 558.814Z",
    fill: "#77BAD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBox);
export default __webpack_public_path__ + "static/media/quote-box.583c2e6ab4a7e86bfe1795fc95d6103b.svg";
export { ForwardRef as ReactComponent };